// extracted by mini-css-extract-plugin
export var chip = "_mo-0";
export var icon = "_mo-1";
export var remove = "_mo-2";
export var removeIcon = "_mo-3";